import { type Row, scalar, upper } from './context.js';
import { REDUCE_DAMAGE_ROLL } from './rolls/reduce-damage-status.js';

export const POST_ROLL_EXCLUDED_LAYERS = ['roll_type_against_dis', 'roll_type_against_adv',
  'roll_type_against_is_rolled_at_max', 'roll_type_against_is_rolled_at_min',
  'triggers_on_next_roll_type_against', 'effect_is_reflected_back'];

/** An item-as-status with this trigger belongs to the post-roll passes, unless it changes the incoming d20. */
export function isPostRollReactionStatus(read: { value: (row: Row, key: string) => unknown; has: (row: Row, key: string) => boolean },
  definition: Row): boolean {
  return upper(scalar(read.value(definition, 'roll_type'))) === REDUCE_DAMAGE_ROLL
    || !POST_ROLL_EXCLUDED_LAYERS.some(key => read.has(definition, key));
}
